import { teacherServiceURL } from '../endpoint';

export function accountURL() {
  const url = new URL(teacherServiceURL);
  url.pathname += 'v3/accounts';
  return url;
}

export function deleteAccountURL() {
  const url = accountURL();
  url.pathname += '/delete';
  return url;
}

export function updateEmailURL() {
  const url = accountURL();
  url.pathname += '/email';
  return url;
}

export function verifyEmailURL() {
  const url = accountURL();
  url.pathname += '/email/verify';
  return url;
}

export function sendEmailVerificationURL() {
  const url = accountURL();
  url.pathname += '/email/send-verification';
  return url;
}

export function checkVerificationStatusURL() {
  const url = accountURL();
  url.pathname += '/email/verification-status';
  return url;
}

export function checkEmailUrl() {
  const url = accountURL();
  url.pathname += '/check';
  return url;
}
